import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  searchContainer: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    width: ({ provider }) => (provider ? 'auto' : 450),
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      overflowY: 'scroll',
    },
  },
  searchInputRoot: {
    width: ({ provider }) => (provider ? 'auto' : 390),
    height: 42,
    borderRadius: 20,
    fontSize: 16,
  },
  searchInput: {
    height: 42,
    padding: '0 0 0 20px',
  },
  searchInputNotchedOutline: {
    top: 0,
    border: '1px solid #FF8C69',
    borderRadius: 20,
    '& legend': {
      display: 'none',
    },
  },
  searchClearButton: {
    minWidth: 'auto',
  },
  searchIcon: {
    marginRight: 8,
  },
  optionSelectContainer: {
    flexGrow: 12,
    width: ({ provider }) => (provider ? 'auto' : 450),
    maxWidth: '100%',
    marginTop: 20,
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  list: {
    width: ({ provider }) => (provider ? 'auto' : 450),
    maxWidth: '100%',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  fixedOptionsSelectContainer: {
    flexShrink: 0,
    width: ({ provider }) => (provider ? 'auto' : 450),
    maxWidth: '100%',
    marginTop: 32,
    overflowY: 'scroll',
    overflowX: 'hidden',
    [theme.breakpoints.down('xs')]: {
      marginTop: 24,
    },
  },
  fixedOptionsList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
}));
